import React from 'react'
import styled from 'styled-components'
import { assetPrefix } from 'config/env_config'

import Link from 'components/link'
import { MEDIA } from 'utils/constants'
import { PAGE_URL } from 'utils'

// Media query
const { MOBILE_UP, MOBILE } = MEDIA

const Logo = styled.a`
  text-align: center;
  text-decoration: none;
  margin:0 auto;
  cursor:pointer;
  display: flex;
  align-items: center;

  @media screen and ${MOBILE_UP} {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    margin:initial;

    img {
      margin-top: 0;
    }
  }

  @media screen and ${MOBILE} {
    img {
      width: 124px;
    }
  }
`

const HeaderLogo = React.forwardRef(({ href, toggleUserSidebar = () => {} }, ref) => (
  <Link href={href || PAGE_URL.SCHEDULING_INDEX}>
    <Logo ref={ref} data-test='logo_header' onClick={toggleUserSidebar}>
      <img data-test='img-logo-header' src={`${assetPrefix}/static/images/logo-petanjo.svg`} alt='Logo Pet Anjo - Spet' />
    </Logo>
  </Link>
))

export default HeaderLogo
